// Lazy load function
const lazyLoad = (file) => () => import(/* webpackChunkName: "[request]" */ `@/views/production/maintenance-order/${file}.vue`);

export default [
    {
        path: "/maintenance-order",
        name: "maintenance-order",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "MaintenanceOrder",
        },
        components: {
            content: lazyLoad("maintenance-order-list"),
        },
    },
    {
        path: "/maintenance-order-draft",
        name: "maintenance-order-draft-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "MaintenanceOrder",
        },
        components: {
            content: lazyLoad("maintenance-order-draft-list"),
        },
    },
    {
        path: "/maintenance-order-open",
        name: "maintenance-order-open-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "MaintenanceOrder",
        },
        components: {
            content: lazyLoad("maintenance-order-open-list"),
        },
    },
    {
        path: "/maintenance-order-completed",
        name: "maintenance-order-completed-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "MaintenanceOrder",
        },
        components: {
            content: lazyLoad("maintenance-order-completed-list"),
        },
    },
];